import { PaginatedResponse } from '@/calendesk/models/DTO/Response/Interface/PaginatedResponse'
import Booking from '@/calendesk/models/DTO/Response/Booking'
import { Expose, Type } from 'class-transformer'

export default class BookingsResponse extends PaginatedResponse {
  @Expose()
  @Type(() => Booking)
  public data!: Array<Booking>
}
